import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Grid, SvgIcon } from "@material-ui/core";
import { Label, ButtonHLPure } from "../../pures";
import "./reliable-signature-password-generation.css";

const ReliableSignaturePasswordGenerationView = (props) => {
  const { step, onHandleNext, onHandleBack } = props;
  const { next, back } = step;
  const { t } = useTranslation();
  const lastInputRef = useRef(null);

  const focusNext = (event) => {
    if (event.key === "Enter") {
      lastInputRef.current.focus();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // props.validatePasswordReliable()
    }
  };

  return (
    <div className="card-description-reliable">
      <Grid item className="identification-margin-button text-center-r">
        <Label title={t("reliableSignaturePasswordGeneration.titlePassword")} />
      </Grid>
      <div className="input-style-password">
        <Grid item xs={12}>
          <div className="change-password-r-input-container">
            <div className="change-password-input-wrapper">
              <i className="fas fa-lock change-password-input-icon" />
            </div>
            <input
              placeholder={t("changePasswordView.placeholderPassword")}
              type="password"
              className="change-password-input"
              id="password"
              onChange={(e) => props.onHandleGeneralChange(e)}
              onKeyDown={focusNext}
            />
            <div
              className={`change-password-input-show-password-container-icon ${props.changePasswordShowPasswordIcon}`}
              onClick={props.onHandleShowPassword}
            >
              <SvgIcon className={`${props.loginShowPasswordIcon}`}>
                {" "}
                <path d="M0 0h24v24H0V0z" fill="none" />{" "}
                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />{" "}
              </SvgIcon>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="change-password-r-input-container">
            <div className="change-password-input-wrapper">
              <i className="fas fa-lock change-password-input-icon" />
            </div>
            <input
              ref={lastInputRef}
              placeholder={t("changePasswordView.placeholderConfirmPassword")}
              type="password"
              className="change-password-input"
              id="confirmPassword"
              onChange={(e) => props.onHandleGeneralChange(e)}
              onKeyDown={handleKeyDown}
            />
            <div
              className={`change-password-input-show-password-container-icon ${props.changePasswordShowPasswordConfirmIcon}`}
              onClick={props.onHandleShowPasswordConfirm}
            >
              <SvgIcon className={`${props.loginShowPasswordIcon}`}>
                {" "}
                <path d="M0 0h24v24H0V0z" fill="none" />{" "}
                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />{" "}
              </SvgIcon>
            </div>
          </div>
        </Grid>
        {/* Mensajes de error */}
        {props.errorForm === true ? (
          <Grid item xs={12}>
            <div className="change-password-container-error-label">
              <p className="change-password-error-label">
                <span>{props.errorMessage}</span>
                <div
                  className="change-password-error-label-icon-close"
                  onClick={props.onHandleHideError}
                >
                  <i className="fas fa-times" />
                </div>
              </p>
            </div>
          </Grid>
        ) : null}
      </div>
      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleNext}
        />
      </div>
    </div>
  );
};

export { ReliableSignaturePasswordGenerationView as default };
